import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";

// MUI Material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-image.jpg";
import { loginSuccess } from "../../../app/authSlice"; // Redux action
import Logo from "assets/images/logos/Government_of_India_logo.png";
import { Box } from "@mui/material";
import { userLogin } from "utils/axios";

function Basic() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("Submitting:", { email, password });

      if (!email || !password) {
        setError("Email and password are required.");
        setLoading(false);
        return;
      }

      console.log("Sending request to API...");
      // const response = await axios.post("https://telelawmh.in/apiv2collectorapp/public/api/login", {
      //   email,
      //   password,
      // });
      const response = await userLogin({ email, password });
      console.log(response, "respoooooo");
      if(response.data && response.access_token){
        localStorage.setItem('accessToken', response.access_token);
      }
      else{
        console.log("API Response:", response.message);
      }

      console.log("API Response:", response.data);

      const access_token = response?.access_token;
      const userRole = response?.message;
      const accessData = response?.accessData; // Extract accessData (talukas, district info)

      if (!access_token || !userRole || !accessData) {
        console.error("Invalid response format:", response.data);
        throw new Error("Missing required fields in API response");
      }

      // Store in localStorage
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("user_role", userRole);
      localStorage.setItem("accessData", JSON.stringify(accessData)); // Store accessData

      console.log("Dispatching loginSuccess:", { accessToken: access_token, userRole, accessData });

      // Dispatch Redux action
      dispatch(loginSuccess({ accessToken: access_token, userRole, accessData }));
        // Redirect to dashboard
        navigate("/dashboard");
    
    } catch (err) {
      console.error("Login Error:", err);
      setError(err.response?.message || "Invalid username or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="#fff"
          borderRadius="lg"
          coloredShadow="dark"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <Box sx={{ width: '100%', height: 'auto' }}>
            <img
              src={Logo}
              alt="Simple Image"
              style={{ width: '100%', height: 'auto' }}
            />
          </Box>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            {error && (
              <MDTypography variant="caption" color="error" textAlign="center">
                {error}
              </MDTypography>
            )}
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
